import React, { useContext, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import EmailSSOForm from './EmailSSOForm/EmailSSOForm';
import PasswordForm from './PasswordForm/PasswordForm';
import './Login.css';
import ScreenContainer from '../../common/ScreenContainer/ScreenContainer';
import { AppContext } from '../../../utils/AppContext';
import { MixpanelContext, SCREENS } from '../../../utils/mixpanel';

const Login = () => {
  const [email, setEmail] = useState('');
  const [isEmailSSOForm, setIsEmailSSOForm] = useState(true);
  const [isLineAnimating, setIsLineAnimating] = useState(false);
  const [errorMessageKey, setErrorMessageKey] = useState<string>();
  const { logoURL } = useContext(AppContext);
  const { t } = useTranslation();
  const { sendMixpanelEvent } = useContext(MixpanelContext);

  const onSSOFailed = (emailToSet: string) => {
    setEmail(emailToSet);
    setIsEmailSSOForm(false);
    sendMixpanelEvent('Proceeding to password screen', {
      email: emailToSet,
      screen: SCREENS.EMAIL_FORM,
    });
  };

  const onLoginAttempt = () => {
    setIsLineAnimating(true);
    setErrorMessageKey(undefined);
  };

  const handleLoginError = () => {
    setIsLineAnimating(false);
  };

  const goBackToEmailForm = () => {
    setErrorMessageKey(undefined);
    setIsEmailSSOForm(true);
    sendMixpanelEvent('Click on login back button', {
      email,
      screen: SCREENS.PASSWORD_FORM,
    });
  };

  return (
    <ScreenContainer
      logoURL={logoURL}
      title={t('loginTitle')}
      isLineAnimating={isLineAnimating}
      errorKey={errorMessageKey}
      topActionComponent={
        !isEmailSSOForm && !isLineAnimating ? (
          <button className="text-button" onClick={goBackToEmailForm}>
            {t('backButton')}
          </button>
        ) : undefined
      }
      bottomActionComponent={
        <span className="privacy-policy">
          {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
          {isEmailSSOForm && (
            <Trans
              t={t}
              i18nKey="privacyPolicy.emailScreenText"
              components={{
                privacyLink: (
                  <a
                    className="privacy-policy-link"
                    href="http://www.optibus.com/uncategorized/optibus-privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            ></Trans>
          )}
        </span>
      }
    >
      {isEmailSSOForm ? (
        <EmailSSOForm
          onSSOFailed={onSSOFailed}
          setErrorMessageKey={setErrorMessageKey}
          email={email}
        />
      ) : (
        <PasswordForm
          email={email}
          onLoginAttempt={onLoginAttempt}
          setErrorMessageKey={setErrorMessageKey}
          handleLoginError={handleLoginError}
        />
      )}
    </ScreenContainer>
  );
};

export default Login;
